import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MaintenanceDetail from './MaintenanceDetail'
import { exportMaintainPlan } from '@/api/api'
import { MaintainItemServiceProxy, MaintainPlanServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import dayjs from 'dayjs'

const misp = new MaintainItemServiceProxy()
const mpsp = new MaintainPlanServiceProxy()

@Component({
  components: {
    MaintenanceDetail
  }
})
export default class Maintenance extends Vue { // 保养项目
  @Prop({ default: "" }) readonly deviceId
  @Prop({ default: () => ({}) }) readonly selectDevice: Object;

  @Watch('deviceId')
  getData() {
    this.reload()
  }

  created(){
    if(this.deviceId !== ""){
      this.reload()
    }
  }

  reload(){
    this.filters = {
      current: 1,
      size: 10
    }
    this.keywords = ""
    this.total = 0
    this.getListPage()
    misp.queryMaintainItemList("").then(res =>{
      this.maintainItemList = res
    })
  }

  getListPage(){
    const maintainPlanSearchDTO = {
      deviceId: this.deviceId,
      deviceTypeId: "",
      filterPlus: false,
      keyWord: "",
      param: {},
    } as any
    this.loading = true
    mpsp.queryMaintainPlanPage(this.filters.current,maintainPlanSearchDTO,this.filters.size).then(res =>{
      if(res){
        this.dataSource = res.records
        this.detailList = []
        this.total = Number(res.total)
        this.loading = false
        if(res.records && res.records.length > 0){
          this.selectId = res.records[0].id
          this.clickRow(this.selectId)
        }
      }
    })
  }

  get columns() {
    return [
      {
        title: this.$t('page_plan_maintenance_application_No'),
        dataIndex: 'code',
        key: 'code',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_program'),
        dataIndex: 'projectName',
        key: 'projectName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_last_maintenance_date'),
        dataIndex: 'preMaintainTime',
        key: 'preMaintainTime',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : "" }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_period'),
        dataIndex: 'intervalTime',
        key: 'intervalTime',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_next_maintenance_date'),
        dataIndex: 'maintainDate',
        key: 'maintainDate',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : "" }
            </span>
          )
        },
      }
    ]
  }

  filters = {
    current: 1,
    size: 10
  }
  keywords = ""
  total = 0
  loading = false
  dataSource = []
  selectId = ""
  detailLoading = false
  detailList = []
  slecetData = {}
  maintainItemList = []
  resizeTimer = null
  tableScrollHeight = 170

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer)
      this.resizeTimer = null
    }
    this.resizeTimer = setTimeout(function(){
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }

  pageIndexchange(value){
    this.filters = {
      current: value,
      size: 10
    }
    this.selectId = ""
    this.getListPage()
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(id){
    this.selectId = id
    this.detailLoading = true
    this.detailList = []
    mpsp.getMaintainPlan(id).then(res =>{
      this.slecetData = res
      this.detailList = res.maintainPlanItemVoList
      this.detailLoading = false
    })
  }

  change(value){
    const list = []
    const data: any = this.slecetData
    value.forEach(res => {
      const value = {
        itemId: res.id
      }
      list.push(value)
    });
    data.maintainDate = dayjs(data.maintainDate).valueOf()
    data.maintainItemList = list
    this.loading = true
    mpsp.editMaintainPlan(data).then(() => {
      this.getListPage()
      this.loading = false
    }).catch(() => {this.loading = false})
  }

  export(){
    const data = {
      deviceId: this.deviceId,
      deviceTypeId: "",
      exportSelected: false,
      keyWord: "",
      selectedRecords: []
    }
    console.log(22)
    exportMaintainPlan(data).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_equipment_maintenance_plan')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }
  render() {
    return (
      <div style="height: 100%;padding-top: 8px;overflow-y: auto;">
        <a-button type="default" style="margin-bottom:8px" onClick={() => this.export()}>{ this.$t('page_product_export')}</a-button>
        <div id="ware-topmodal" style="height: 260px;overflow-y: auto;overflow-x: hidden;position: relative;">
          <ml-table
            size="small"
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            loading={this.loading}
            dataSource={this.dataSource}
            columns={this.columns}
            scroll={{ y: 170, x: 1000 }}
            selectRowKey={this.selectId}
            customRow={(record) => {
              return {
                on: { // 事件
                  click: () => this.clickRow(record.id),      // 点击行
                },
              };
            }}
          ></ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            total={this.total}
            pageSize={this.filters.size}
            current={this.filters.current}
            show-total={total => `${this.showTotal(total)}`}
            onChange={this.pageIndexchange}
            onShowSizeChange={this.pageIndexchange}
          ></a-pagination>
        </div>
        <div v-resize={{axis: 'y', cb: this.changeY }}></div>
        <div>
          <maintenance-detail
            loading={this.detailLoading}
            data={this.detailList}
            maintainItemList={this.maintainItemList}
            onChange={value => this.change(value)}
            canEdit={true}
          ></maintenance-detail>
        </div>
      </div>
    )
  }
}
